"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tinycolor2_1 = __importDefault(require("tinycolor2"));
const shadeBasesConvertToPaletteShades_1 = __importDefault(require("./shadeBasesConvertToPaletteShades"));
const controlColorGetValueFromSpecification = (shadeBases) => (specification) => {
    if (!specification) {
        return undefined;
    }
    if (specification.type === 'custom') {
        return specification.value;
    }
    const paletteShades = (0, shadeBasesConvertToPaletteShades_1.default)(shadeBases);
    const specificationValue = specification.value;
    if (!specificationValue) {
        return undefined;
    }
    const { base, shade, alpha } = specificationValue;
    if (!base) {
        return undefined;
    }
    const colorShades = paletteShades[base];
    if (!colorShades) {
        return undefined;
    }
    const hexColor = colorShades[`${shade}`].value;
    if (alpha === null || alpha === undefined) {
        return hexColor;
    }
    const rgbColor = (0, tinycolor2_1.default)(hexColor).clone();
    return rgbColor.setAlpha(alpha).toString();
};
exports.default = controlColorGetValueFromSpecification;
